import { Group, Stack, Title, Card, Text } from '@mantine/core';
import { AnimateDiv } from '@/components/Common/AnimateDiv';

export const Voice = () => {
  return (
    <section className="flex flex-col mt-32 max-w-[1520px] mx-auto px-[20px] lg:px-[80px]">
      <AnimateDiv>
        <Group wrap="nowrap" justify="space-between" className="mt-10 items-end sm:items-start">
          <Stack>
            <Title order={4} className="text-xl lg:text-5xl font-bold leading-tight">
              音声対話も可能
              <br />
              自然な会話であらゆるシーンに対応
            </Title>
            <Text className="text-sm lg:text-xl text-black/60 mt-4">
              AIとの自然な音声対話でユーザーが求める内容を的確に回答。
              <br />
              電話システムやメッセージングアプリともシームレスに連携します。
            </Text>
          </Stack>
          <img src="/home/voice.png" alt="" className="w-28 md:w-40 lg:w-60 h-28 md:h-40 lg:h-60" />
        </Group>
      </AnimateDiv>

      <Group align="stretch" className="lg:flex-nowrap">
        <AnimateDiv className="rounded-md !bg-[#F8FCFF] py-6 lg:py-10 px-0 w-full lg:w-1/2">
          <Stack gap="xs" className="px-4 lg:px-8">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="5" y="5" width="22" height="22" stroke="black" strokeWidth="2" />
              <path
                d="M8.50016 26.9996V8.49961H27.0002L27.0002 4.99961C19.6669 5.04426 4.90016 5.10678 4.50016 4.99961C4.10016 4.89243 4.33349 19.6216 4.50016 26.9996H8.50016Z"
                fill="black"
              />
              <path d="M12 13L16 17L12 21" stroke="black" strokeWidth="2" />
              <path d="M18 20.5H24.5" stroke="black" strokeWidth="2" />
            </svg>

            <Title order={5} className="text-base lg:text-2xl font-bold">
              簡単埋め込み
            </Title>
            <Text c="dimmed" className="text-sm lg:text-xl">
              サイトに1行のコードを追加するだけ。複雑な設定は不要です。
            </Text>
          </Stack>
          <AnimateDiv delay={0.4} className="mx-6 mt-16">
            <img src="/home/voice1.png" alt="" />
          </AnimateDiv>
        </AnimateDiv>
        <AnimateDiv className="rounded-md !bg-gray-50 py-6 lg:py-10 px-0 w-full lg:w-1/2">
          <Stack gap="xs" className="px-4 lg:px-8">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 10H28V6.5H4V22H7V10Z" fill="black" />
              <path d="M28 7V22H24.75V24.8496L21.6445 22.2354L21.3652 22H4V7H28Z" stroke="black" strokeWidth="2" />
              <path
                d="M15.2662 19H13.377L15.8308 11.7273H18.171L20.6248 19H18.7356L17.0275 13.5597H16.9707L15.2662 19ZM15.014 16.1378H18.9629V17.473H15.014V16.1378Z"
                fill="black"
              />
            </svg>

            <Title order={5} className="text-base lg:text-2xl font-bold">
              自動言語認識付き多言語サポート
            </Title>
            <Text c="dimmed" className="text-sm lg:text-xl">
              リアルタイム音声認識で、自動的に言語を検出して対応します。
            </Text>
          </Stack>
          <AnimateDiv delay={0.4} className="mx-6 mt-8">
            <img src="/home/voice2.png" alt="" />
          </AnimateDiv>
        </AnimateDiv>
      </Group>

      <Group align="stretch" className="mt-4 lg:flex-nowrap">
        <AnimateDiv className="rounded-md !bg-gray-50 py-6 lg:py-10 px-0 w-full lg:w-1/2">
          <Stack gap="xs" className="px-4 lg:px-8">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g filter="url(#filter0_i_4308_1538)">
                <rect x="10" y="3" width="12" height="16" rx="6" fill="#F9FAFB" />
              </g>
              <rect x="11" y="4" width="10" height="14" rx="5" stroke="black" strokeWidth="2" />
              <path
                d="M7 11V13C7 17.9706 11.0294 22 16 22V22C20.9706 22 25 17.9706 25 13V11"
                stroke="black"
                strokeWidth="2"
              />
              <path d="M22 27H10" stroke="black" strokeWidth="2" />
              <path d="M16 22V26.5" stroke="black" strokeWidth="2" />
              <defs>
                <filter
                  id="filter0_i_4308_1538"
                  x="10"
                  y="3"
                  width="12"
                  height="16"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="4" />
                  <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0" />
                  <feBlend mode="normal" in2="shape" result="effect1_innerShadow_4308_1538" />
                </filter>
              </defs>
            </svg>
            <Title order={5} className="text-base lg:text-2xl font-bold">
              自然で人間らしい対話
            </Title>
            <Text c="dimmed" className="text-sm lg:text-xl">
              遅延を抑えたスムーズな対話で、まるで人と話しているかのような体験を実現。
            </Text>
          </Stack>
          <AnimateDiv delay={0.4} className="mx-10 mt-10">
            <img src="/home/voice3.png" alt="" />
          </AnimateDiv>
        </AnimateDiv>
        <AnimateDiv className="rounded-md !bg-[#F9F8FF] py-6 lg:py-10 px-0 w-full lg:w-1/2">
          <Stack gap="xs" className="px-4 lg:px-8">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.7665 15.4999C10.8096 15.5003 12.1408 16.8688 12.2235 18.8615L12.2267 19.0572V20.3515C12.2267 21.2088 12.0024 21.8248 11.5586 22.4896L11.3122 22.8474L11.1805 23.0498C11.1164 23.1451 11.0791 23.2559 11.0725 23.3705C11.0725 23.6337 11.2447 23.7874 11.869 23.9949L12.8647 24.2986C13.3659 24.4623 13.754 24.6344 14.0999 24.8672C14.8087 25.3465 15.2727 26.0435 15.4769 26.9294L15.4888 27.0071L15.4972 27.2095C15.5006 27.3343 15.5005 27.5014 15.4988 27.7073L15.4719 29H2.03934L2.00558 27.8997C1.99814 27.6523 1.99814 27.4047 2.00558 27.1573L2.01402 27.0543L2.03433 26.9261C2.24189 26.0419 2.70419 25.3482 3.40788 24.8672C3.70318 24.6681 4.02722 24.5129 4.43052 24.3729L4.7681 24.2614L5.32657 24.0945C6.2277 23.8312 6.46223 23.6725 6.46223 23.3721C6.45946 23.2875 6.4364 23.2047 6.39484 23.1309L6.32732 23.0128L5.8464 22.304C5.51612 21.7961 5.32951 21.2083 5.30639 20.603L5.30297 20.3498V19.064C5.27767 16.965 6.63404 15.5004 8.7665 15.4999Z"
                fill="black"
              />
              <path
                d="M27.1932 17.1876C26.8284 19.7117 25.6569 22.0501 23.8536 23.8537C22.0504 25.6572 19.7122 26.8292 17.1881 27.1945V25.485C19.261 25.1337 21.1733 24.1462 22.66 22.6595C23.7329 21.5865 24.5457 20.2917 25.0472 18.875H22.2505V17.1875L27.1932 17.1876Z"
                fill="black"
              />
              <path
                d="M22.2665 2C24.3096 2.00032 25.6407 3.36878 25.7234 5.36147L25.7268 5.55729V6.85158C25.7268 7.7105 25.5023 8.32471 25.0585 8.98957L24.8122 9.34733L24.6806 9.54988C24.6165 9.64515 24.5792 9.75585 24.5726 9.87046C24.5726 10.1354 24.7447 10.2873 25.3691 10.4949L26.3647 10.7987C26.8659 10.9624 27.254 11.1344 27.5999 11.3673C28.3087 11.8465 28.7727 12.5435 28.9769 13.4295L28.9887 13.507L28.9972 13.7096C29.0006 13.8344 29.0006 14.0015 28.9989 14.2074L28.9719 15.4999H15.5393L15.5057 14.3998C15.4982 14.1523 15.4982 13.9046 15.5057 13.6572L15.5141 13.5543L15.5343 13.426C15.7419 12.5418 16.2043 11.8482 16.908 11.3673C17.2033 11.1682 17.5273 11.013 17.9306 10.8729L18.2681 10.7615L18.8267 10.5944C19.7277 10.3312 19.9623 10.1725 19.9623 9.87046C19.9594 9.78634 19.9362 9.70414 19.8948 9.63085L19.8273 9.5127L19.3464 8.80403C19.0161 8.29621 18.8295 7.70839 18.8064 7.10306L18.8029 6.84987V5.56402C18.7776 3.46509 20.134 2.00044 22.2665 2Z"
                fill="black"
              />
              <path
                d="M13.813 5.51509C12.0327 5.81704 10.3653 6.58891 8.98317 7.75093C7.60101 8.91296 6.55421 10.423 5.95097 12.125H8.75055V13.8125H3.80612C4.17126 11.2882 5.3431 8.94971 7.14663 7.14618C8.95016 5.34265 11.2887 4.17083 13.813 3.80568V5.51509Z"
                fill="black"
              />
            </svg>
            <Title order={5} className="text-base lg:text-2xl font-bold">
              業務シーン別アバターセット
            </Title>
            <Text c="dimmed" className="text-sm lg:text-xl">
              さまざまなビジネスシナリオに合わせたキャラクターを標準搭載。
            </Text>
          </Stack>
          <AnimateDiv delay={0.4} className="mx-12 lg:mx-24 mt-10">
            <img src="/home/voice4.png" alt="" />
          </AnimateDiv>
        </AnimateDiv>
      </Group>
    </section>
  );
};
